export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/checksum.worker.b91e2de5.worker.js");
}
